<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import { fly, slide } from 'svelte/transition';

	let {
		buttonType = 'anchor',
		color = 'yellow',
		icon = null,
		loading = null,
		disabled = null,
		children,
		class: classNames = '',
		onclick = null,
		href = null,
		active = true,
		tag = null,
		transition = null,
		transitionDuration = 0,
		formaction = null,
		value = null,
		name = null,
		...props
	} = $props();

	if (!transition) {
		transition = (node) =>
			slide(node, { axis: 'x', duration: transitionDuration });
	}

	// Determine which kind of element to render
	const Element = tag ?? (buttonType === 'anchor' ? 'a' : 'button');
</script>

{#snippet spinner()}
	<div
		transition:fly
		class="spinner absolute top-0 right-0 grid h-full place-items-center"
	>
		<svg
			class="m-2 w-6 stroke-[var(--a-text-color)]"
			stroke="currentColor"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			><g class="spinner"
				><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3" /></g
			></svg
		>
	</div>
{/snippet}
{#if active}
	<div class="button relative grid w-full place-items-center">
		<svelte:element
			this={Element}
			onclick={disabled
				? (event) => {
						event.preventDefault();
					}
				: onclick}
			href={disabled ? '' : href}
			{...props}
			{disabled}
			{value}
			{name}
			class={[
				`wrap text-indow-white relative rounded-sm px-6 py-4 text-center text-base leading-none font-bold tracking-widest hyphens-none uppercase no-underline hover:no-underline focus:no-underline disabled:cursor-not-allowed`,
				{
					'grid grid-cols-[1rem,1fr] gap-4': icon,
					'bg-indow-yellow !text-indow-white': color == 'yellow',
					'bg-indow-blue !text-indow-white': color == 'blue',
					'bg-indow-green !text-indow-white': color == 'green',
					'bg-indow-grey-dark !text-indow-white': color == 'grey',
					'bg-indow-white !text-indow-blue border-2': color == 'white',
					'!bg-indow-red !text-indow-white': color == 'red',
					'!bg-indow-grey cursor-not-allowed': disabled,
				},
				classNames,
			]}
			transition:transition
			{formaction}
		>
			{#if Element === 'button' && icon}
				<Image descriptionSlot="" src={icon} />
			{/if}
			{@render children?.()}
			{#if loading}
				{@render spinner()}
			{/if}
		</svelte:element>
	</div>
{/if}

<style>
	.spinner {
		transform-origin: center;
		animation: spinner_rotate 2s linear infinite;
	}
	.spinner circle {
		stroke-linecap: round;
		animation: spinner_offset 1.5s ease-in-out infinite;
	}
	@keyframes spinner_rotate {
		100% {
			transform: rotate(360deg);
		}
	}
	@keyframes spinner_offset {
		0% {
			stroke-dasharray: 0 150;
			stroke-dashoffset: 0;
		}
		47.5% {
			stroke-dasharray: 42 150;
			stroke-dashoffset: -16;
		}
		95%,
		100% {
			stroke-dasharray: 42 150;
			stroke-dashoffset: -59;
		}
	}
</style>
